import React from 'react';
import { IntegrationProps } from '../types';

export const InteraktSettings: React.FC<IntegrationProps> = ({ config, onChange }) => {
    return (
        <div className="space-y-4">
            {/* API KEY INPUT */}
            <div>
                <label className="block text-sm font-semibold text-slate-700 mb-1">
                    Interakt API Key (Public Key)
                </label>
                <input 
                    type="password" 
                    value={config.apiKey || ''}
                    onChange={(e) => onChange({ apiKey: e.target.value })}
                    className="w-full p-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none transition-all"
                    placeholder="Paste your API key here"
                />
            </div>

            {/* TEMPLATE NAME INPUT - Restored as per request */}
            <div>
                <label className="block text-sm font-semibold text-slate-700 mb-1">
                    Template Name
                </label>
                <input 
                    type="text" 
                    value={config.templateName || ''}
                    onChange={(e) => onChange({ templateName: e.target.value })}
                    className="w-full p-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none transition-all"
                    placeholder="e.g. video_proof_notification"
                />
                <p className="text-xs text-slate-500 mt-1">
                    Enter the exact name of the template created in your Interakt dashboard.
                </p>
            </div>

            {/* TEMPLATE INSTRUCTIONS */}
            <div className="bg-slate-50 p-4 rounded-lg border border-slate-200 text-sm">
                <h4 className="font-bold text-slate-800 mb-2">Required Template Format</h4>
                <p className="text-slate-600 mb-2">
                    Please ensure your Interakt template body matches this structure so variables are mapped correctly:
                </p>
                <div className="bg-white p-3 rounded border border-slate-300 font-mono text-xs text-slate-600 mb-3 whitespace-pre-wrap">
{`Hi {{1}},

Your Order #{{2}} has been packed and is ready for dispatch! 📦

To ensure quality, we have recorded a video proof of your package.

You can watch your packing video here: {{3}}`}
                </div>
                <ul className="text-xs text-slate-500 space-y-1 list-disc pl-4">
                    <li><strong>Variable 1:</strong> Customer Name</li>
                    <li><strong>Variable 2:</strong> Order ID</li>
                    <li><strong>Variable 3:</strong> Video Link</li>
                </ul>
            </div>
        </div>
    );
};
